// src/components/ui/calendar/month/MonthViewDateCell/MonthViewDateCell.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import { CalendarDateHeader, CalendarOverflowIndicator } from '../../core';

const MonthViewDateCell = ({
  date,
  currentDate,
  isToday = false,
  isSelected = false,
  isClickable = false,
  onClick,
  children, // Events content
  overflowInfo = { overflowCount: 0, previewIsHidden: false },
  onOverflowClick,
  // Availability props
  hasAvailability = false,
  viewingPartnerAvailability = false,
  // Block mode prop
  isBlockSelected = false,
  className = ''
}) => {
  const isCurrentMonth = date.getMonth() === currentDate.getMonth();

  const handleClick = () => {
    if (isClickable && onClick) {
      onClick(date, 9); // Default to 9 AM
    }
  };

  const handleOverflowClick = (e) => {
    e.stopPropagation();
    if (onOverflowClick) {
      onOverflowClick(date);
    } else {
      console.log('Show more events for', date);
    }
  };

  return (
    <div
      className={cn(
        // Exact styling from your current MonthView date cell
        "min-h-24 border-r border-b border-slate-600/30 last:border-r-0 p-1",
        "transition-colors duration-200",
        isClickable && "cursor-pointer",
        !isCurrentMonth && "bg-slate-800/10 text-slate-500",
        isToday && "bg-blue-500/5 border-blue-500/20",
        isSelected && "bg-slate-700/20",

        // Block mode: selected day
        isBlockSelected && "bg-blue-500/20 border-blue-400/40",
        isBlockSelected && "hover:bg-blue-500/30",

        // Purple availability styling (only when not block-selected)
        !isBlockSelected && hasAvailability && "bg-purple-600/20 border-purple-500/30",
        !isBlockSelected && hasAvailability && "hover:bg-purple-600/30",

        // Default hover (no availability, no block selected)
        !isBlockSelected && !hasAvailability && "hover:bg-slate-800/20",

        className
      )}
      onClick={handleClick}
    >
      {/* Date number and overflow indicator row */}
      <div className="flex items-center justify-between mb-1">
        {/* Date number using CalendarDateHeader component */}
        <CalendarDateHeader
          date={date}
          view="month"
          isToday={isToday}
          isSelected={isSelected}
          isCurrentMonth={isCurrentMonth}
          showWeekday={false}
        />

        {/* NEW: Availability indicator dot */}
        {hasAvailability && (
          <div className="w-2 h-2 bg-purple-400 rounded-full flex-shrink-0 mr-1"></div>
        )}

        {/* Overflow indicator using CalendarOverflowIndicator component */}
        {(overflowInfo.overflowCount > 0 || overflowInfo.previewIsHidden) && (
          <CalendarOverflowIndicator
            count={overflowInfo.overflowCount + (overflowInfo.previewIsHidden ? 1 : 0)}
            hasPreview={overflowInfo.previewIsHidden}
            onClick={handleOverflowClick}
            size="xs"
            className="flex-shrink-0"
          />
        )}
      </div>

      {/* Events container */}
      {children}
    </div>
  );
};

export default MonthViewDateCell;